import Vue from "vue";
import VueRouter from "vue-router";
// import firebase from "firebase/compat/app";
// import store from '@/store/store.js';
// import C from "@/constants"

Vue.use(VueRouter);

const routes = [
  {
    name: "Login",
    path: "/login",
    component: () => import("@/views/Login.vue"),
  },
  {
    name: "Register",
    path: "/register",
    component: () => import("@/views/Register.vue"),
  },
  {
    path: "/",
    component: () => import("@/views/Layout.vue"),
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        name: "Dashboard",
        path: "",
        component: () => import("@/components/Configurator.vue"),
      },
      {
        name: "Configurator",
        path: "/configurator",
        component: () => import("@/components/Configurator.vue"),
      },
      {
        name: "Configurator",
        path: "/configurator-clarity",
        component: () => import("@/components/ConfiguratorClarity.vue"),
      },
      {
        name: "ConfiguratorV2",
        path: "/configurator-v2",
        component: () => import("@/components/ConfiguratorV2.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// make sure only logged-in users have access to the content while only guests(+not signed-in users) see register & login
router.beforeEach((to, from, next) => {
  console.log("NEXT: ");
  console.log(to);
  console.log("FROM: ");
  console.log(from);
  // const currentUser = firebase.auth().currentUser;
  // const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // redirect to login if not signed in
  // if(requiresAuth && !currentUser) next('Login');
  // skip login if user is already signed in
  // else if (!requiresAuth && currentUser) next ('Dashboard');
  // continue navigation otherwise
  // else next();
  next();
});

export default router;
